import React, {Component} from 'react';
import CardList from '../components/CardList';
import SearchBox from '../components/SearchBox';//Creating Searchbox component to use in App ftn
//import {robots} from './robots';//curly braces are used to get multiple robots from robots.js 
import Scroll from '../components/Scroll';
import ErrorBoundry from '../components/ErrorBoundry';
import './App.css';




class App extends Component{
	constructor(){
		super();
		this.state = {
			robots: [],
			searchfield: ''
		}
		console.log("constructor");
	}

	componentDidMount(){
		fetch('https://jsonplaceholder.typicode.com/users')
			.then(response=> {
				return response.json();
			})
			.then(users => {
				this.setState({robots: users})
			})
		console.log("componentDidMount");
	}

	onSearchChange = (event) =>{
		this.setState({searchfield: event.target.value});
		/*console.log(event.target.value);*/
		
		// console.log(filterRobots);
	}

render(){

		const {robots , searchfield} = this.state;

		const filteredRobots = robots.filter(robot =>{
			return robot.name.toLowerCase().includes(searchfield.toLowerCase());
		})
		console.log("render");
		if(!robots.length){//can also use ternary here instead of if else
			return <h1>Loading...</h1>
		}else{
			return(
		<div className = 'tc'>
			<h1 className = "f1">RoboBuddies</h1>
			<SearchBox searchChange = {this.onSearchChange}/>

			<Scroll>
				<ErrorBoundry>
					<CardList robots = {filteredRobots}/>
				</ErrorBoundry>
			</Scroll>
		</div>
	);
		}
	

	

	}
	
}

export default App;